import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import commonPl from './locales/pl/common.json'
import authPl from './locales/pl/auth.json'
import dashboardPl from './locales/pl/dashboard.json'
import documentsPl from './locales/pl/documents.json'
import budgetPl from './locales/pl/budget.json'
import settingsPl from './locales/pl/settings.json'
import profilePl from './locales/pl/profile.json'
import validationPl from './locales/pl/validation.json'
import adminPl from './locales/pl/admin.json'
import landingPl from './locales/pl/landing.json'

import commonEn from './locales/en/common.json'
import authEn from './locales/en/auth.json'
import dashboardEn from './locales/en/dashboard.json'
import documentsEn from './locales/en/documents.json'
import budgetEn from './locales/en/budget.json'
import settingsEn from './locales/en/settings.json'
import profileEn from './locales/en/profile.json'
import validationEn from './locales/en/validation.json'
import adminEn from './locales/en/admin.json'
import landingEn from './locales/en/landing.json'

const resources = {
  pl: {
    common: commonPl,
    auth: authPl,
    dashboard: dashboardPl,
    documents: documentsPl,
    budget: budgetPl,
    settings: settingsPl,
    profile: profilePl,
    validation: validationPl,
    admin: adminPl,
    landing: landingPl,
  },
  en: {
    common: commonEn,
    auth: authEn,
    dashboard: dashboardEn,
    documents: documentsEn,
    budget: budgetEn,
    settings: settingsEn,
    profile: profileEn,
    validation: validationEn,
    admin: adminEn,
    landing: landingEn,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'documents', 'budget', 'settings', 'profile', 'validation', 'admin', 'landing'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  })

export default i18n
